import log from 'loglevel'
import { Button, Box, Card, CardContent, Grid, Typography } from '@mui/material'
import {
  Confirm,
  Form,
  useNotify,
  useRedirect,
  useTranslate
} from 'react-admin'
import React from 'react'
import { doExecute } from './functions'

log.setLevel(log.levels.DEBUG)

const ExecuteButton: React.FC<{ id: string; target: string }> = ({
  id,
  target
}) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [open, setOpen] = React.useState(false)
  const onClick = (): void => {
    setOpen(true)
  }
  const onClose = (): void => {
    setOpen(false)
  }
  const onConfirm = (): void => {
    setOpen(false)
    doExecute(id, target)
      .then((_status: number | undefined) => {
        notify(`resources.${target}.execute.notify.complete`)
        redirect(target === 'cognito' ? '/admin' : '/')
      })
      .catch(() => {
        notify(`resources.${target}.execute.notify.error`)
        redirect(target === 'cognito' ? '/admin' : '/')
      })
  }
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="large"
        sx={{ borderRadius: '10px', width: '150%' }}
        onClick={onClick}>
        <Typography variant="button">
          {translate(`resources.${target}.execute.buttons.execute`)}
        </Typography>
      </Button>
      <Confirm
        isOpen={open}
        title={`resources.${target}.execute.dialog.title`}
        content={`resources.${target}.execute.dialog.content`}
        onConfirm={onConfirm}
        onClose={onClose}
        cancel={`resources.${target}.execute.dialog.cancel`}
        confirm={`resources.${target}.execute.dialog.confirm`}
      />
    </>
  )
}

export const Execute: React.FC<{ id: string; target: string }> = ({
  id,
  target
}) => {
  const translate = useTranslate()
  return (
    <Card raised sx={{ width: '1280px', marginBottom: '1em' }}>
      <CardContent>
        <Form>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center'
            }}>
            <Box sx={{ width: '1280px' }}>
              <Box
                sx={{
                  marginLeft: '0.5em',
                  marginRight: '0.5em'
                }}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={0.5}
                  sx={{
                    marginTop: '0.1em'
                  }}>
                  <Grid item xs={7}>
                    <Typography>
                      {translate(`resources.${target}.execute.confirm`)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <ExecuteButton id={id} target={target} />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Form>
      </CardContent>
    </Card>
  )
}
